import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { PasswordDTO, UserDTO } from '../model/user-model';
import { UserConfig } from '../model/reservation.model';

@Injectable({
  providedIn: 'root'
})
export class UserConfigService {
  userConfig = new BehaviorSubject<UserConfig | undefined>(undefined);
  userConfig$: Observable<UserConfig | undefined> = this.userConfig.asObservable();
  CONFIG_PATH = 'api/user-config';

  constructor(private http: HttpClient) {}

  getTimezone(): string | undefined {
    return this.userConfig.getValue()?.timeZone;
  }

  getUserConfiguration(): Observable<UserConfig> {
    return this.http.get<UserConfig>(this.CONFIG_PATH).pipe(tap((userConfig) => this.userConfig.next(userConfig)));
  }

  getUserConfigurationInit(): Promise<UserConfig | undefined> {
    return this.http
      .get<UserConfig>(this.CONFIG_PATH)
      .toPromise()
      .then((userConfig) => {
        if (userConfig) {
          this.userConfig.next(userConfig);
        }
        return userConfig;
      })
      .catch((error: HttpErrorResponse) => this.handleError(error));
  }

  getUserConfigurationDetails(): Observable<UserDTO> {
    return this.http.get<UserDTO>(`${this.CONFIG_PATH}/account`);
  }

  updateUserConfig(userConfig: UserDTO): Observable<boolean> {
    return this.http.post<boolean>(`${this.CONFIG_PATH}/account`, userConfig);
  }

  updateUserPassword(passwordDTO: PasswordDTO): Observable<boolean> {
    return this.http.post<boolean>(`${this.CONFIG_PATH}/password`, passwordDTO);
  }

  private handleError(error: HttpErrorResponse): Promise<never> {
    if ([503, 502, 504, 403].includes(error.status)) {
      window.location.href = 'assets/error.html';
    }
    return Promise.reject(error);
  }
}
